const themeConfig = () => {
  //Process theme config
  const urlParams = new URL(window.location.href).searchParams;
  const mainColor = urlParams.get("mainColor");
  const noteColor = urlParams.get("noteColor");
  const buttonColor = urlParams.get("themePrimary");
  return {
    mainBackgroundColor: mainColor || "rgba(0, 21, 41, 0.04)",
    noteBodyBackgroundColor: noteColor || "rgba(0, 21, 41, 0.02)",
    buttonBackgroundColor:
      buttonColor && buttonColor.length > 0 ? `#${buttonColor}` : "#001529",
  };
};

const config = {
  apiGatewayEndpoint: process.env.REACT_APP_API_GATEWAY_ENDPOINT,
  customerSearchDebounce: process.env.REACT_APP_CUSTOMER_SEARCH_DEBOUNCE,
  cognitoAppClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  cognitoAppClientSecret: process.env.REACT_APP_COGNITO_APP_CLIENT_SERECT,
  cognitoClientDomain: process.env.REACT_APP_COGNITO_CLIENT_DOMAIN,
  tokenEnabled: true,
  themeConfig: themeConfig(),
};

export default config;
